import styled from "styled-components";

export const RAIL_WIDTH = 240;
export const TOPBAR_HEIGHT = 60;

export const Rail = styled.nav`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  width: ${RAIL_WIDTH}px;
  box-sizing: border-box;
  background: #ffffff;
  border-right: 1px solid var(--line);
  padding: 16px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  z-index: 1100;
`;

export const Logo = styled.a`
  display: flex;
  padding: 6px 8px 18px;
  cursor: pointer;
  img {
    height: 36px;
    width: auto;
  }
`;

export const GroupTitle = styled.span`
  font-family: var(--font-sans);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.6px;
  color: #80868b;
  text-transform: uppercase;
  padding: 14px 14px 6px;
`;

export const NavLink = styled.a<{ $active: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  height: 44px;
  padding: 0 14px;
  border-radius: 10px;
  font-family: var(--font-sans);
  font-size: 14px;
  font-weight: 500;
  color: ${(p) => (p.$active ? "var(--brand-700)" : "var(--text)")};
  background: ${(p) => (p.$active ? "var(--brand-50)" : "transparent")};
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
  transition: background 0.15s, color 0.15s;
  & > svg {
    color: inherit;
  }
  &:hover {
    background: ${(p) => (p.$active ? "var(--brand-50)" : "#f3f6fa")};
    color: ${(p) => (p.$active ? "var(--brand-700)" : "var(--ink)")};
  }
`;

export const UserCard = styled.div`
  margin-top: auto;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 10px;
  border-radius: 12px;
  background: var(--bg);
  min-width: 0;
`;

export const Avatar = styled.span`
  width: 34px;
  height: 34px;
  border-radius: 999px;
  background: var(--brand-50);
  color: var(--brand-700);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
`;

export const UserText = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
  .name {
    font-family: var(--font-sans);
    font-size: 13px;
    font-weight: 600;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: var(--ink);
  }
  .role {
    font-size: 12px;
    color: var(--text-muted);
  }
`;

export const LogoutButton = styled.button`
  margin-left: auto;
  border: 0;
  background: transparent;
  color: var(--text-muted);
  cursor: pointer;
  display: inline-flex;
  padding: 4px;
  border-radius: 8px;
  &:hover {
    background: var(--brand-50);
    color: var(--brand-700);
  }
`;

export const TopBar = styled.header`
  position: fixed;
  top: 0;
  left: ${RAIL_WIDTH}px;
  right: 0;
  height: ${TOPBAR_HEIGHT}px;
  box-sizing: border-box;
  background: #ffffff;
  border-bottom: 1px solid var(--line);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px 0 28px;
  z-index: 1090;
`;

export const Breadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--text-muted);
  .current {
    color: var(--ink);
    font-family: var(--font-sans);
    font-weight: 500;
  }
  & > svg {
    font-size: 18px;
    color: #bdc1c6;
  }
`;

/** Bolinha com quantas novidades a pessoa ainda não viu. */
export const ContadorNovidades = styled.span`
  margin-left: auto;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  box-sizing: border-box;
  border-radius: 10px;
  background: #d93025;
  color: #ffffff;
  font-size: 11px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
`;

/** Aviso na barra de cima quando saiu coisa nova; leva ao mural. */
export const NovidadesNaBarra = styled.button`
  display: flex;
  align-items: center;
  gap: 6px;
  max-width: 50%;
  height: 32px;
  padding: 0 12px;
  border: 1px solid #c6dafc;
  border-radius: 16px;
  background: #e8f0fe;
  color: #1967d2;
  font-family: var(--font-sans);
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  .material-icons {
    font-size: 18px;
  }

  &:hover {
    background: #d2e3fc;
  }
`;
